import { Card } from '@app/components/various/Card';
import { useGetBuyerOptions } from '@app/utils/hooks/accounts/useGetBuyerOptions';
import { Row } from '@tanstack/react-table';
import { Buyer } from '@typings';
import { useTranslation } from 'react-i18next';

interface Props {
  accountId: string;
  buyers: Buyer.Base[];
  row: Row<Buyer.Base>;
  onEdit: (buyerId: string) => void;
}

export const BuyersListCard = ({ accountId, buyers, row, onEdit }: Props) => {
  const { t } = useTranslation(['common']);
  const { buyer: buyerId = '', email = '', firstName, lastName, phoneNumber = '', mobileNumber = '' } = row.original;
  const getOptions = useGetBuyerOptions({ accountId, buyers, onEdit });

  return (
    <Card.Wrapper variant="gray">
      <Card.Title>
        <span data-sentry-mask>{`${firstName} ${lastName}`.trim()}</span>
      </Card.Title>
      <Card.AttributeList>
        <Card.AttributeLink name={t('common:email')} value={email} to={`mailto:${email}`} />
        <Card.Attribute name={t('common:phone')} value={phoneNumber} />
        <Card.Attribute name={t('common:mobile')} value={mobileNumber} />
      </Card.AttributeList>
      <Card.Menu title={t('common:option_other')} items={getOptions(buyerId)} />
    </Card.Wrapper>
  );
};
